import { useLogoutMutation } from 'api/core/generated';
import { AppApiVersions } from 'app-constants';

import { useRudderStack } from './use-rudderstack';

export const useLogout = () => {
  const { reset } = useRudderStack();
  const [logoutRequest, { loading }] = useLogoutMutation({
    context: { apiVersion: AppApiVersions.core },
  });
  const logOut = () => {
    reset();
    return logoutRequest();
  };
  return {
    logOut,
    logOutLoading: loading,
  };
};
